import locationApi from '../api/locations';

import {
    SET_AVAILABLE_LOCATIONS,
} from './types';


function sortingFunc(el1, el2) {
    let a = String(el1).trim().toLowerCase().split(' ').join('0');
    let b = String(el2).trim().toLowerCase().split(' ').join('0');
    return naturalCompare(b, a);
}

export default {
    namespaced: true,
    state: {
        availableLocations: [],
        defaultSelected : {}
    },
    actions: {
        async getAvailableLocations({ commit }) {
            return locationApi.getAvailableLocations()
                .then(({ data }) => {
                    commit(SET_AVAILABLE_LOCATIONS, data)
                });
        }
    },
    mutations: {
        [SET_AVAILABLE_LOCATIONS](state, data) {
            data.unshift({name: 'All', id: 0});
            state.availableLocations = data;
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/locations.js